import React from 'react'
import { IconCube, IconHandbagSimple, IconStorefront } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { ProductSkuAvailabilityRow } from './ProductSkuAvailabilityRow'

export const ProductSkuAvailabilityLoading = () => (
  <>
    <ProductSkuAvailabilityRow
      icon={<IconCube />}
      title={<FormattedMessage id="pdp.sku-availability.delivery.title" />}
      message={null}
      status="available"
      rightColumn={null}
      busy
    />
    <ProductSkuAvailabilityRow
      icon={<IconStorefront />}
      title={<FormattedMessage id="pdp.sku-availability.pickup.title" />}
      message={null}
      status="available"
      rightColumn={null}
      busy
    />
    <ProductSkuAvailabilityRow
      icon={<IconHandbagSimple />}
      title={<FormattedMessage id="pdp.sku-availability.take-away.title" />}
      message={null}
      status="available"
      rightColumn={null}
      busy
    />
  </>
)
